<main id="viewport" [ngClass]="{'loading': showLoader}">
  @if (showPage) {
    <router-outlet />
  }
</main>
